import React from "react";
import './MatchList.css';

class MatchList extends React.Component {
  matchListItem(PersonID1, TitleID, PersonID2, PersonID1PersonName, TitleName, TitleYear, PersonID2PersonName) {
    // console.log(`MatchList - matchListItem called `);
    return (
        // console.log(`MatchList - matchListItem mapping: ${val.actor1Name} in ${val.movieName} with ${val.actor2Name}`);
        <tr className="match-list-text match-list-row" key={`${PersonID1}-${TitleID}-${PersonID2}`}>
          <td className="match-list-actor">{PersonID1PersonName}</td>
          <td className="match-list-movie">{TitleName} ({TitleYear})</td>
          <td className="match-list-actor">{PersonID2PersonName}</td>
        </tr>
    );
  }

  render() {
    const matchList = this.props.matchList;

    if (matchList && matchList.length > 0) {
    return (
          <table className="match-list-table">
            <tbody>
              {
                matchList.map((val) => (
                  this.matchListItem(val.PersonID1, val.TitleID, val.PersonID2, val.PersonID1PersonName, val.TitleName, val.TitleYear, val.PersonID2PersonName)
                  // console.log(`MatchList - matchListItem mapping: ${val.actor1Name} in ${val.movieName} with ${val.actor2Name}`)
                ))
              }
              {/* <tr><td>test</td></tr> */}
            </tbody>
          </table>
      );
    }
  }
}

export default MatchList;